import React, { useState } from "react";
import { TextField, Chip, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import { grantRecommendations } from "src/api/grantsRecommendation";

const useStyles = makeStyles(() => ({
  chip: {
    margin: "0.25rem",
  },
}));

const KeywordInput = ({ onResults }) => {
  const classes = useStyles();
  const [inputValue, setInputValue] = useState("");
  const [keywords, setKeywords] = useState([]);
  const [loading, setLoading] = useState(false);

  // Handle text change
  const handleChange = (e) => {
    setInputValue(e.target.value);
  };

  // Split by commas or Enter
  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();
      addKeywordsFromInput();
    }
  };

  // Add keywords from current input value
  const addKeywordsFromInput = () => {
    const newKeywords = inputValue
      .split(",")
      .map((kw) => kw.trim())
      .filter((kw) => kw && !keywords.includes(kw));

    if (newKeywords.length > 0) {
      setKeywords((prev) => [...prev, ...newKeywords]);
      setInputValue("");
    }
  };

  // Remove a keyword chip
  const handleDelete = (kwToDelete) => {
    setKeywords((prev) => prev.filter((kw) => kw !== kwToDelete));
  };

  // Submit keywords to API
  const handleSubmit = async () => {
    if (keywords.length === 0) return;

    try {
      setLoading(true);
      const response = await grantRecommendations({ 
        keyword: keywords.join(", "),
       });
      console.log(response)
      if (onResults) onResults(response);
    } catch (err) {
      console.error("Error fetching recommendations:", err);
      if (onResults) onResults({ error: err.message });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col space-y-4 w-full max-w-md mx-auto p-4">
      <div className="flex flex-wrap items-center border border-gray-300 rounded-xl p-2 focus-within:border-blue-500 transition duration-200">
        {keywords.map((kw) => (
          <Chip
            key={kw}
            label={kw}
            onDelete={() => handleDelete(kw)}
            className={clsx(classes.chip, "bg-blue-100 text-blue-800")}
          />
        ))}

        <TextField
          value={inputValue}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          placeholder="Type keywords and press Enter or comma"
          InputProps={{
            disableUnderline: true,
            classes: { input: "focus:outline-none w-full" },
          }}
          className="flex-1 bg-transparent"
        />
      </div>

      <Button
        variant="contained"
        color="primary"
        onClick={handleSubmit}
        disabled={loading}
        className="w-full py-2 rounded-lg"
      >
        {loading ? "Submitting..." : "Get Recommendations"}
      </Button>
    </div>
  );
};

export default KeywordInput;
